import React from 'react';
import { Badge, Group, Tooltip, Box, Flex } from '@mantine/core';
import { IconLink, IconArrowsExchange } from '@tabler/icons-react';
import { FormTitle } from './FormTitle';

function ConnectedDataIcon() {
  return (
    <Tooltip
      label="This section updates automatically from data connections with the provider"
      position="bottom"
      withArrow
      multiline
      w={200}
    >
      <Box
        style={{
          backgroundColor: 'var(--mantine-color-blue-1)',
          borderRadius: '12px',
          padding: '4px 6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'help',
          height: '22px',
          minWidth: '22px',
        }}
      >
        <IconLink size={14} style={{ color: 'var(--mantine-color-blue-6)' }} />
      </Box>
    </Tooltip>
  );
}

export function useConnectedDataIcon(isUpdatedAutomatically: boolean): React.ReactNode {
  return isUpdatedAutomatically ? <ConnectedDataIcon /> : undefined;
}

function ConnectedDataBadge() {
  return (
    <Tooltip
      label="Sections indicated with this icon update automatically from data connections with the provider"
      position="bottom"
      withArrow
      multiline
      w={200}
    >
      <Badge
        variant="light"
        color="blue"
        size="xl"
        leftSection={<IconLink size={16} />}
        style={{ cursor: 'help' }}
      >
        Connected data
      </Badge>
    </Tooltip>
  );
}

export function FormTitleWithConnectedDataBadge({
  title,
  showBadge,
}: {
  title: string;
  showBadge: boolean;
}) {
  return (
    <Group>
      <FormTitle title={title} />
      {showBadge && <ConnectedDataBadge />}
    </Group>
  );
}

function CurrencyConversionIcon() {
  return (
    <Tooltip
      label="Some fund holdings include currency conversions"
      position="bottom"
      withArrow
      multiline
      w={200}
    >
      <Flex
        bg="var(--mantine-color-yellow-1)"
        align="center"
        justify="center"
        p="xs"
        style={{
          borderRadius: '12px',
          cursor: 'help',
          height: '22px',
          minWidth: '22px',
        }}
      >
        <IconArrowsExchange size={14} style={{ color: 'var(--mantine-color-yellow-7)' }} />
      </Flex>
    </Tooltip>
  );
}

export function useCurrencyConversionIcon(hasCurrencyConversions: boolean): React.ReactNode {
  return hasCurrencyConversions ? <CurrencyConversionIcon /> : undefined;
}

function CurrencyConversionBadge() {
  return (
    <Tooltip
      label="Some fund holdings have been converted from foreign currencies to GBP"
      position="bottom"
      withArrow
      multiline
      w={200}
    >
      <Badge
        variant="light"
        color="yellow"
        size="xl"
        leftSection={<IconArrowsExchange size={16} />}
        style={{ cursor: 'help' }}
      >
        Currency conversions
      </Badge>
    </Tooltip>
  );
}

export function FormTitleWithBadges({
  title,
  showConnectedBadge,
  showCurrencyBadge,
}: {
  title: string;
  showConnectedBadge: boolean;
  showCurrencyBadge: boolean;
}) {
  return (
    <Group>
      <FormTitle title={title} />
      {showConnectedBadge && <ConnectedDataBadge />}
      {showCurrencyBadge && <CurrencyConversionBadge />}
    </Group>
  );
}
